import React from 'react'
import SubHeader from '../SubHeader'
import KYRGenericCardComponent from '../KYRGenericCardComponent'
import {KYRScreenLayout} from '../../../assets/styles/layout'
import IncomingDelivery from '../IncomingDelivery'
import AbstractKYRScreen from './AbstractKYRScreen'
import {withStyles} from '@mui/styles'
import {SCREEN_TIMELINE} from '../KYRConstants'
import {navigateToScreen} from '../../../actions/kyrWidgetActions'
import {connect} from 'react-redux'
import {compose} from 'redux'
import KYRWidgetBackButton from '../KYRWidgetBackButton'

const styles = theme => ({
  scrollContainer: {
    ...KYRScreenLayout,
    marginLeft: '40px',
  },
})

class IncomingDeliveryComponent extends AbstractKYRScreen {
  render() {
    return (
      <KYRGenericCardComponent residentId={this.props.navParams.residentId}>
        <SubHeader title={'package details'} LeftIconComponent={KYRWidgetBackButton} />
        <div className={this.props.classes.scrollContainer}>
          <IncomingDelivery deliveryId={this.props.navParams.primaryRecordId} />
        </div>
      </KYRGenericCardComponent>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  dispatchNavigateToTimeline: residentId => navigateToScreen(dispatch, SCREEN_TIMELINE, {residentId: residentId}),
})

export default compose(withStyles(styles), connect(undefined, mapDispatchToProps))(IncomingDeliveryComponent)
